import React from "react";
import { Card, Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";
import PromotionServiceListItem from "./PromotionServiceListItem";

export default function PromotionServicesList({
  promotions,
  promotionType,
  promotionItemType,
  heading,
  noPromotionsHeading,
  isAdmin = false,
  loading = false,
}) {
  return (
    <div className="manage-job-list">
      <Segment basic style={{ ...SEMANTIC_DIV }} disabled={loading}>
        <div className="body-bold-text">{heading}</div>
        <div className="manage-job-list-container">
          <Card.Group>
            {promotions.length > 0 ? (
              promotions.map((item) => (
                <PromotionServiceListItem
                  promotionType={promotionType}
                  item={item}
                  key={item.id}
                  promotionItemType={promotionItemType}
                  isAdmin={isAdmin}
                />
              ))
            ) : (
              <span className="manage-item-list-no-item">
                {noPromotionsHeading}
              </span>
            )}
          </Card.Group>
        </div>
      </Segment>
    </div>
  );
}
